import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import {
  withStyles,
  Fab,
  Tooltip,
  Backdrop,
  Slide,
  Typography,
  Fade,
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  Box,
  CircularProgress,
} from '@material-ui/core'
import { MdSettings, MdAccountCircle, MdVerifiedUser } from 'react-icons/md'
import { TiThMenu, TiUser } from 'react-icons/ti'
import { RiLogoutBoxLine, RiUser3Fill, RiUserSettingsFill, RiUserFill } from 'react-icons/ri'
import { CgMenuGridR, CgMenuGridO, CgClose } from 'react-icons/cg'
import { IoMdHelp, } from 'react-icons/io'
import { IoSettingsSharp } from 'react-icons/io5'
import { HiOutlineUser } from 'react-icons/hi'
import { BsArrowLeft } from 'react-icons/bs'
import { AiOutlineArrowLeft, AiOutlineUserSwitch } from 'react-icons/ai'
import AdminMenu from './Admin'
import SwitchUsers from './SwitchUsers'
import UserSettings from './Settings'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function UserMenu(props) {
  const {handleLogout, userLvl} = props
  const otherAccounts = JSON.parse(localStorage.getItem("accounts")) && JSON.parse(localStorage.getItem("accounts")).length > 0 ? true : false
  const [menuOpen, setMenuOpen] = useState(false)
  const [adminOpen, setAdminOpen] = useState(false)
  const [settingsOpen, setSettingsOpen] = useState(false)
  const [switchAccount, setSwitchAccount] = useState(false)

  const handleOpenMenu = () => {
    setMenuOpen(!menuOpen)
  }

  const handleCloseMenu = () => {
    setMenuOpen(false)
    setAdminOpen(false)
    setSettingsOpen(false)
    setSwitchAccount(false)
  }

  const handleOpenSettings = () => {
    setSettingsOpen(!settingsOpen)
  }

  const handleCloseSettings = () => {
    setSettingsOpen(false)
  }

  const handleAdminOpen = () => {
    setAdminOpen(!adminOpen)
  }

  const handleSwitchAccount = () => {
    setSwitchAccount(!switchAccount)
  }

  const logout = () => {
    handleLogout()
  }

  const defaultMenuItems = [
    {option: "logout", icon: <RiLogoutBoxLine />, onClickMethod: logout, path: null},
    {option: "support", icon: <IoMdHelp />, onClickMethod: null, path: null},
    {option: "settings", icon: <IoSettingsSharp />, onClickMethod: handleOpenSettings, path: null},
    {option: "switch clients", icon: <AiOutlineUserSwitch />, onClickMethod: handleSwitchAccount, path: null},
    {option: "admin", icon: <MdVerifiedUser />, onClickMethod: handleAdminOpen, path: null},
  ]

  const position = [
    {icon: "100px", text: "115px", timeout: 0},
    {icon: "215px", text: "230px", timeout: 250},
    {icon: "330px", text: "345px", timeout: 500},
    {icon: "445px", text: "460px", timeout: 750},
    {icon: "560px", text: "575px", timeout: 1000},
  ]

  let viewedMenuItems = otherAccounts ? defaultMenuItems : defaultMenuItems.filter(({option}) => option !== "switch clients")

  return (
    <div id="user-menu">
      <Backdrop
        className="backdrop"
        open={menuOpen}
      >
        {viewedMenuItems.map(({option, icon, onClickMethod, timeout, path}, i) => (
          <div className="menu-options" key={`${option.split(" ")[0]}-${i}`}>
            <Slide direction="up" in={menuOpen && !adminOpen && !settingsOpen && !switchAccount} timeout={position[i].timeout} mountOnEnter unmountOnExit>
              <Fab
                className={`menu-item ${option.split(" ")[0]}`}
                style={{bottom: position[i].icon}}
                // component={Link} 
                // to={path}
                onClick={onClickMethod}
              >
                {icon}
              </Fab>
            </Slide>
            <Slide direction="left" in={menuOpen && !adminOpen && !settingsOpen && !switchAccount} timeout={500} mountOnEnter unmountOnExit>
              <Fade in={menuOpen}>
                <Typography variant="caption" className={`menu-item-text ${option.split(" ")[0]}-text`} style={{bottom: position[i].text}}>{option.toUpperCase()}</Typography>
              </Fade>
            </Slide>
            <div style={{display: "flex", justifyContent: "center"}}>
              {option === "admin" ?
              <AdminMenu handleAdminOpen={handleAdminOpen} open={adminOpen} handleClose={handleCloseMenu} userLvl={userLvl}/>
              : option === "switch clients" ?
              <SwitchUsers open={switchAccount} handleSwitchAccount={handleSwitchAccount} userLvl={userLvl}/>
              : option === "settings" ?
              <UserSettings handleClose={handleCloseSettings} open={settingsOpen} handleSettingsOpen={handleOpenSettings} userLvl={userLvl}/>
              : null}
            </div>
          </div>
        ))}
      </Backdrop>

      <Tooltip title={menuOpen ? "CLOSE MENU" : "USER MENU"} placement="bottom-end">
        <Fab className={menuOpen ? "fab-clicked" : "fab"} size={"small"} onClick={handleOpenMenu}>
          {menuOpen ?
            <CgClose className="fab-icon" onClick={handleCloseMenu}/>
          :
            <RiUserFill className="fab-icon"/>
          }
        </Fab>
      </Tooltip>
    </div>
  )
}
